import {GetObjectPropertyValue, ToString} from './shared/utils';

export const ACCOUNTEMAILS_BILLING = 0;
export const ACCOUNTEMAILS_DAILYREPORT = 1;
export const ACCOUNTEMAILS_WEEKLYREPORT = 2;

export const APP_FEATURE_ID = {
    AESEncryption: 'SERVICEFEATURE_1', 
    DownAlerts: 'SERVICEFEATURE_3',
    HealthCheck: 'SERVICEFEATURE_4',
    WhiteLabel: 'SERVICEFEATURE_6',
    PublicAPI: 'SERVICEFEATURE_7',
    BackupDownload: 'APPFEATURE_BACKUPDOWNLOAD',
    //BackupRestore: 'APPFEATURE_BACKUPRESTORE',
    ScheduleBusinessDays: 'APPFEATURE_SCHEDULEBUSINESSDAYS',
    ScheduleMonthDays: 'APPFEATURE_SCHEDULEMONTHDAYS',
    RunMissedBackups: 'APPFEATURE_RUNMISSEDBACKUPS',
    ArchiveSplitToVolumes: 'APPFEATURE_ARCHIVESPLITTOVOLUMES',
    OutputFileFormat: 'APPFEATURE_OUTPUTFILEFORMAT',
    JobEdit: 'APPFEATURE_JOBEDIT',
    DatabaseRestore: 'APPFEATURE_DATABASERESTORE',
    FolderRestore: 'APPFEATURE_FOLDERRESTORE',
    MonitorDatabasesFromJobsOnly: 'APPFEATURE_MONITORDATABASESFROMJOBSONLY',
    DatabaseRestoreSettings: 'APPFEATURE_DATABASERESTORESETTINGS',
    SetAgentNameRemotely:  'APPFEATURE_SETAGENTNAMEREMOTELY',
    ControlAgentConnectionsRemotely:  'APPFEATURE_CONTROLAGENTCONNECTIONSREMOTELY',
    JobRunsTooLongAlert: 'APPFEATURE_JOBRUNSTOOLONGALERT',
}

export const BACKUPOBJECT_TYPE = {
    Unknown: 0,
    DatabaseFull: 1,
    DatabaseDifferential: 2,
    DatabaseTransactionLog: 3,
    Folder: 4,
    DatabaseIncremental: 5,
}

export const ACCOUNTEMAILS_TYPE = {
    Billing: 0,
    DailyReport: 1,
    WeeklyReport: 2
}

export const DESTINATION_TYPE = {
    Folder: 1,
    FTP: 2,
    AmazonS3: 3,
    Dropbox: 4,
    GoogleDrive: 5,
    OneDrive: 6,
    Box: 7,
    AzureStorage: 8,
    OneDrive4Business: 9,
    BackblazeB2: 10,
    YandexDisk: 11,
    S3Compatible: 12
}

export const JOB_TYPE = {
    Backup: 1,
    Maintenance: 2,
    Restore: 3
}

export const JOBTRIGGER_TYPE = {
    RestoreDatabase: 1
}

export const APPLICATION_TYPE = {
    SqlBakForWindows: 0,
    //SbfForWindows: 1,
    SqlBakForLinux: 2
}
APPLICATION_TYPE.getOSIconClassName = appTypeId => {
    let result = '';

    if (!isNaN(appTypeId)) {
        switch (appTypeId) {
            case APPLICATION_TYPE.SqlBakForWindows:
                result = "sbkico-windows";
                break;

            case APPLICATION_TYPE.SqlBakForLinux:
                result = "sbkico-linux";
                break;
        }
    }

    return result;
}

export const SCRIPT_TYPE = {
    CommandLine: 0,
    Sql: 1
}

export const SCRIPT_POINT = {
    Before: 0,
    After: 1
}

export const SERVER_TYPE = {
    LocalSQLServer: 1,
    AzureSQLServer: 2,
    RemoteSQLServer: 3,
    MySQLServer: 4,
    PhpMyAdminServer: 5,
    PostgreSql: 6,
    AmazunRdsSQLServer: 7,
    MySQLWithXtrabackup: 8,
    MongoDB: 9,
}

export const SEVERITY_TYPE = {
    Debug: 1,   //text-secondary
    Info: 2,    //text-body
    Warning: 3, //text-warning
    Error: 4    //text-danger
}
SEVERITY_TYPE.textClasses = {
    [SEVERITY_TYPE.Debug]: 'text-secondary',
    [SEVERITY_TYPE.Info]: 'text-body',
    [SEVERITY_TYPE.Warning]: 'text-warning',
    [SEVERITY_TYPE.Error]: 'text-danger',
}
SEVERITY_TYPE.icons = {
    [SEVERITY_TYPE.Debug]: SEVERITY_TYPE.textClasses[SEVERITY_TYPE.Debug],
    [SEVERITY_TYPE.Info]: 'sbkico-ok fa1 fa1-check text-success',
    [SEVERITY_TYPE.Warning]: SEVERITY_TYPE.textClasses[SEVERITY_TYPE.Warning],
    [SEVERITY_TYPE.Error]: 'sbkico-close fa1 fa1-close ' + SEVERITY_TYPE.textClasses[SEVERITY_TYPE.Error],
}

export const DOWNLOAD_STATUS = {
    Created: 0,
    InProgress: 1,
    Completed: 2,
    Error: 3,
    Canceled: 4
}

export const RESTORE_STATUS = {
    Created: 0,
    Downloading: 1,
    Downloaded: 2,
    Uncompressing: 3,
    Uncompressed: 4,
    Restoring: 5,
    Restored: 6,
    Failed: 7,
    Cancelled: 8
}

export const BACKUP_STATUS = {
    Unknown: 0,
    Success: 1,
    Warning: 2,
    Failed: 3,
    Skipped: 4
}
BACKUP_STATUS.textClasses = {
    [BACKUP_STATUS.Unknown]: 'text-body',
    [BACKUP_STATUS.Success]: 'text-success',
    [BACKUP_STATUS.Warning]: 'text-warning',
    [BACKUP_STATUS.Failed]: 'text-danger',
    [BACKUP_STATUS.Skipped]: 'text-warning', //'text-body',
}

export const INVOICE_STATE = {
    Deleted: -10,
    Pending: 0,
    Paid: 10,
    Refunded: 20
}
INVOICE_STATE.textClass = id => {
    let result = 'text-body';

    switch (id) {
        case INVOICE_STATE.Pending:
            result = 'text-secondary';
            break;
        case INVOICE_STATE.Paid:
            result = 'text-success';
            break;
        case INVOICE_STATE.Refunded:
                result = 'text-danger';
                break;
    }

    return result;
}

export const PAYMENT_STATE = {
    Error: -20,
    Pending: 0,
    Success: 10
}
PAYMENT_STATE.textClass = id => {
    let result = 'text-body';

    switch (id) {
        case PAYMENT_STATE.Pending:
            result = 'text-secondary';
            break;
        case PAYMENT_STATE.Success:
            result = 'text-success';
            break;
        case PAYMENT_STATE.Error:
            result = 'text-danger';
            break;
    }

    return result;
}

export const UrlBuilder = {
    Account:                (urlParams) => `/account/${GetObjectPropertyValue(urlParams, 'ActiveTab', '')}`,
    AccountProfile:         () => '/account/profile',
    AccountLabel:           () => '/account/label',
    AccountPassword:        () => '/account/password',
    AccountCreditCard:      () => '/account/cc',
    Dashboard:              () => '/dashboard',
    EmailSettings:          () => '/account/emailsettings',
    Payment:                (amount) => Boolean(amount) ? `/pay?amount=${amount}` : '/pay',
    PaymentPaper:           (urlParams) => `/account/paymentpaper/${GetObjectPropertyValue(urlParams, 'PaymentId', 'InvalidPaymentId')}`,
    InvoicePaper:           (urlParams) => `/account/invoicepaper/${GetObjectPropertyValue(urlParams, 'InvoiceId', 'InvalidInvoiceId')}`,
    JobRunPaper:            (urlParams) => `/app/jobrunpaper/${GetObjectPropertyValue(urlParams, 'JobRunId', 'InvalidId')}?tz=${GetObjectPropertyValue(urlParams, 'TimeZoneId', null)}`,
    SubscriptionChange:     () => '/subscription/change',
    SubscriptionUpgrade:    () => '/subscription/upgrade',
    JobRunView:             (urlParams) => {
        const jobRunId = GetObjectPropertyValue(urlParams, 'JobRunId', '');
        const pageNum = GetObjectPropertyValue(urlParams, 'PageNum', '');
        let result = `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/backup/${jobRunId}`;

        if (!isNaN(jobRunId) && !isNaN(pageNum) && (pageNum > 1)) {
            result += `/${pageNum}`;
        }

        return result;
    },
    JobView:                (urlParams) => `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/view/${GetObjectPropertyValue(urlParams, 'PageNum', '')}`,
    JobEdit:                (urlParams) => 
    {
        let result = `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/edit`;
        const returnUrl = ToString(GetObjectPropertyValue(urlParams, 'ReturnUrl', ''));

        if (returnUrl) {
            result += `?returnUrl=${encodeURIComponent(returnUrl)}`;
        }

        return result;
    },
    JobEditDestination:     (urlParams) => {
        let result = `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/edit/destination/${GetObjectPropertyValue(urlParams, 'DestinationId', 'InvalidDestinationId')}`;
        const returnUrl = ToString(GetObjectPropertyValue(urlParams, 'ReturnUrl', ''));

        if (returnUrl) {
            result += `?returnUrl=${encodeURIComponent(returnUrl)}`;
        }

        return result;
    },
    JobNew:                 (urlParams) => `/app/job/new/${GetObjectPropertyValue(urlParams, 'JobTypeId', 'InvalidJobTypeId')}/${GetObjectPropertyValue(urlParams, 'AgentId', '')}`,
    JobClone:               (urlParams) => `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/copy`,
    JobJson:                (urlParams) => `/app/job/${GetObjectPropertyValue(urlParams, 'JobId', 'InvalidJobId')}/json`,
    AgentView:              (urlParams) => `/monitoring/computer/${GetObjectPropertyValue(urlParams, 'AgentId', '') || ''}/${GetObjectPropertyValue(urlParams, 'ActiveTab', '')}`,
    //AgentView:              (urlParams) => `/server/${GetObjectPropertyValue(urlParams, 'AgentId', '') || ''}/${GetObjectPropertyValue(urlParams, 'ActiveTab', '')}`,

    LoginAs:                (urlParams) => {
        let result = `/loginas/${GetObjectPropertyValue(urlParams, 'AccountId', '') || ''}`;
        const url = GetObjectPropertyValue(urlParams, 'url', '');

        if (Boolean(url)) {
            result += `?url=${encodeURIComponent(url)}`;
        }

        return result;

    },

    AccountInfo: (urlParams) => {
        let result = `/admin/accountinfo/${GetObjectPropertyValue(urlParams, 'AccountId', 'InvalidAccountId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    PaymentInfo: (urlParams) => {
        let result = `/admin/paymentinfo/${GetObjectPropertyValue(urlParams, 'PaymentId', 'InvalidPaymentId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    InvoiceInfo: (urlParams) => {
        let result = `/admin/invoiceinfo/${GetObjectPropertyValue(urlParams, 'InvoiceId', 'InvalidInvoiceId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    MailInfo: (urlParams) => {
        let result = `/admin/mailinfo/${GetObjectPropertyValue(urlParams, 'MailId', 'InvalidMailId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    AgentInfo: (urlParams) => {
        let result = `/admin/agentinfo/${GetObjectPropertyValue(urlParams, 'AgentId', 'InvalidAgentId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    AffiliateInfo: (urlParams) => {
        let result = `/admin/affiliateinfo/${GetObjectPropertyValue(urlParams, 'AffiliateId', 'InvalidAffiliateId')}`;

        const listSource = GetObjectPropertyValue(urlParams, 'ListSource', '');

        if (Boolean(listSource)) {
            result += `?src=${listSource}`;
        }

        return result;
    },
    AffiliatePayoutInfo: (urlParams) => {
        let result = `/admin/affiliatepayoutinfo/${GetObjectPropertyValue(urlParams, 'PayoutId', 'InvalidPayoutId') || ''}`;

        const affiliateId = GetObjectPropertyValue(urlParams, 'AffiliateId', '');

        if (Boolean(affiliateId)) {
            result += `?affiliateId=${affiliateId}`;
        }

        return result;
    },
}

export const REFRESH_TIMER = {
    AccountBaseInfo: 'AccountBaseInfo',
    DownloadRuns: 'DownloadRuns',
    RestoreRuns: 'RestoreRuns',
    Invoices: 'Invoices',
    Payments: 'Payments',
    Agents: 'Agents',
    Jobs: 'Jobs'
}

export const FTP_PROTOCOL_TYPE = {
    FTP: 0,
    FTPS_Implicit: 1,
    FTPS_Explicit: 2,
    SFTP: 3
}
// FTP_PROTOCOL_TYPE.GetDefaultPort = pt => pt == FTP_PROTOCOL_TYPE.SFTP ? 22 : 21;
FTP_PROTOCOL_TYPE.GetDefaultPort = function (pt) {
    switch (pt) {
        case FTP_PROTOCOL_TYPE.SFTP: return 22;
        case FTP_PROTOCOL_TYPE.FTPS_Implicit: return 990;
    }

    return 21;
}

export const SSH_AUTHENTICATION_METHOD = {
    Password: 1,
    PublicKey: 4,
}

export const CREDITCARD_GATEWAY_TYPE = {
    Stripe: 'Stripe',
    PayPal: 'PayPal',
}